export default __webpack_public_path__ + "static/media/dt-4.a7f553b0.webp";